// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import ColoredInImage from "./ColoredInImage";
import ColorPalette from "./ColorPalette";
import { saveSvgAsPng } from "save-svg-as-png";
import swal from "@sweetalert/with-react";
import { useTranslation } from "react-i18next";

export default function ColoringPage() {
  const { t, i18n } = useTranslation();
  debugger;
  let { id } = useParams();
  const [userImage, setUserImage] = useState({
    id: "canada",
    fillColors: ["white"],
  });
  const [color, setColor] = useState("blue");
  const images = useSelector((state) => state.images);
  const originalImages = useSelector((state) => state.originalImages);
  let currentImage = images.find((image) => image.id === id);
  let currentOriginalImage = originalImages.find((image) => image.id === id);

  useEffect(() => {
    setUserImage(currentImage);
  }, [currentImage]);

  const onFillColor = (i) => {
    let newFillColors = userImage.fillColors.slice(0);
    newFillColors[i] = color;

    setUserImage({
      ...userImage,
      fillColors: newFillColors,
    });
  };

  const showOriginalImage = () => {
    swal({
      text: `${t("description.Original Image")}`,
      content: (
        <div>
          <img src={currentOriginalImage.src} alt="coloring" width="100%" />
        </div>
      ),
    });
  };

  const saveImage = () => {
    saveSvgAsPng(
      document.getElementById("coloring-image-container").children[0],
      `${t("description.Colored Image")}.png`,
      { scale: 3 }
    );
    swal(
      `${t("description.Download Complete")}`,
      `${t("description.This image has been saved")}`,
      "success"
    );
  };

  return (
    <div className="coloring-page">
      <ColorPalette currentColor={color} changeColor={setColor} />
      <div class="coloring-main">
        <div id="coloring-image-container">
          <ColoredInImage
            size="large"
            component={userImage.id}
            onFill={onFillColor}
            fillColors={userImage.fillColors}
          />
        </div>

        <div class="buttons">
          {currentOriginalImage && (
            <button onClick={showOriginalImage}>
              {t("description.Show original image")}
            </button>
          )}
          <button onClick={saveImage}>{t("description.Download")}</button>
        </div>
      </div>
      <div className="image-description">
        <h2 id="description-heading">{i18n.language === "en"
            ? currentImage.nameEN
            : i18n.language === "fr"
            ? currentImage.nameFR
            : i18n.language === "es"
            ? currentImage.nameES
            : ""}</h2>
        <hr />

        <p>
          {i18n.language === "en"
            ? currentImage.descriptionEN
            : i18n.language === "fr"
            ? currentImage.descriptionFR
            : i18n.language === "es"
            ? currentImage.descriptionES
            : ""}
        </p>
      </div>
    </div>
  );
}
